/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import type { Column } from '@tanstack/react-table'
import { getTableColumnWidthPx, TableColumnMeta } from 'utils/table/tableColumnWidths'

interface UiTanstackTableColGroupProps<TData> {
    columns: Column<TData, unknown>[]
}

const UiTanstackTableColGroup = <TData,>({ columns }: UiTanstackTableColGroupProps<TData>) => {
    const columnWidthsPx = columns.map((column) =>
        getTableColumnWidthPx(column.columnDef.meta as TableColumnMeta | undefined, column.id)
    )
    const totalMinWidthPx = columnWidthsPx.reduce((sum, widthPx) => sum + (widthPx ?? 0), 0)

    return (
        <colgroup>
            {columns.map((column, index) => {
                const widthPx = columnWidthsPx[index]

                if (!widthPx || totalMinWidthPx <= 0) {
                    return <col key={column.id} />
                }

                return (
                    <col
                        key={column.id}
                        style={{
                            width: `${(widthPx / totalMinWidthPx) * 100}%`,
                            minWidth: `${widthPx}px`,
                        }}
                    />
                )
            })}
        </colgroup>
    )
}

export default UiTanstackTableColGroup